import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "loader-body" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.$props.href)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        target: "_blank",
        href: _ctx.$props.href,
        class: _normalizeClass(['bc-button', _ctx.classes])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("button", _mergeProps({
        key: 1,
        disabled: _ctx.$props.disabled || _ctx.$props.loading
      }, _ctx.$attrs, {
        class: ['bc-button', _ctx.classes]
      }), [
        _renderSlot(_ctx.$slots, "default"),
        (_ctx.$props.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true)
      ], 16, _hoisted_2))
}